import React from 'react';
import { socialMedia } from '../data/mock';
import { Heart, Instagram, Facebook, Music2, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent mb-4">
              Laura Sommerfeld
            </h3>
            <p className="text-gray-400 text-sm">
              Moderne Schlagermusik mit Herz und Leidenschaft. Erlebe einzigartige Konzerte und neue Musik.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors text-sm"
                >
                  Über mich
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('music')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors text-sm"
                >
                  Musik
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors text-sm"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">
              Folge mir
            </h4>
            <div className="flex gap-4">
              <a
                href={socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-full flex items-center justify-center text-gray-400 hover:text-pink-400 hover:border-pink-400 hover:bg-pink-500/10 transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href={socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-full flex items-center justify-center text-gray-400 hover:text-blue-400 hover:border-blue-400 hover:bg-blue-500/10 transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
              <a
                href={socialMedia.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-full flex items-center justify-center text-gray-400 hover:text-cyan-400 hover:border-cyan-400 hover:bg-cyan-500/10 transition-all duration-300"
              >
                <Music2 size={18} />
              </a>
              <a
                href={socialMedia.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-full flex items-center justify-center text-gray-400 hover:text-red-400 hover:border-red-400 hover:bg-red-500/10 transition-all duration-300"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} Laura Sommerfeld. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-2 text-gray-400 text-sm">
            <span>Gemacht mit</span>
            <Heart size={16} className="text-red-500 fill-red-500 animate-pulse" />
            <span>für Schlagermusik</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
